import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { Languages } from "../../inputs/languages-input";
import { FiPlusCircle } from "react-icons/fi";

import { StepNavigation } from "../navigation";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { createTutorProfile } from "../../../../store/profile/profileActions";
import { FileInput, TextInput } from "../../../inputs";
import { Editor } from '@tinymce/tinymce-react';
import { getYoutubeID } from "../../../../utils";
import { setUser } from "../../../../store/auth/authSlice";
import Langs from '../../../../utils/data/langs.json'

const TutorProfileStep = ({ setCurrentStep, setActiveTab, previousStep = 2 }) => {
    const formRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const languages = Langs.map((lang) => { return { value: lang.value, label: lang.name + " - " + lang.nativeName } })
    const {
        register,
        handleSubmit,
        control,
        watch,
        setError,
        getValues,
        formState: { errors },
    } = useFormContext();

    const {
        fields: speaksFields,
        append: speaksAppend,
        remove: speaksRemove
    } = useFieldArray({
        control,
        name: "speak",
    });

    const {
        fields: teachFields,
        append: teachAppend,
        remove: teachRemove
    } = useFieldArray({
        control,
        name: "teach",
    });

    const onSubmit = async (data) => {
        setIsLoading(true);
        await dispatch(createTutorProfile(data))
            .then(() => {
                setIsLoading(false);
                dispatch(setUser(data.user))
                setCurrentStep(4);
            });
    }
    const description = watch("description")
    const teachValue = watch("teach");
    const speaksValue = watch("speak");
    const nextStep = () => {
        formRef.current.requestSubmit();
    }
    const currentAvatar = getValues("avatar");
    return (
        <form ref={formRef} id="tutor-profile" onSubmit={handleSubmit(onSubmit)} className="pb-[50px] text-center [&_h2]:text-nt-blue [&_h3]:text-nt-blue" style={{ textAlign: "center" }}>
            {(!currentAvatar || (currentAvatar.length && currentAvatar[0] instanceof Blob) ) ? <div className="my-4">
                <FileInput
                    name="avatar"
                    label="Avatar"
                    errors={errors}
                    register={register}
                    setError={setError}
                    control={control}
                    style="avatar"
                    required={false}
                    defaultValue={watch("avatar")}
                />
            </div> : null}
            <h3 className="text-left">Languages taught</h3>

            {teachFields.map((field, index) => (
                <Languages
                    currentValue={teachValue}
                    key={field.id}
                    errors={errors}
                    control={control}
                    register={register}
                    id={field.id}
                    remove={teachRemove}
                    name="teach"
                    index={index}
                    required={true}
                />
            ))}


            {teachFields.length < 2 && <button
                type="button"
                className='inline m-auto'
                onClick={() => {
                    teachAppend({ lang: languages.filter((l) => !teachValue.map((v) => v.lang).includes(l.value))[0].value, level: "C1" });
                }}
            >
                <FiPlusCircle size={30} color='#191d51' fontWeight={700} />
            </button>}

            <h3 className="text-left">Languages spoken</h3>

            {speaksFields.map((field, index) => (
                <Languages
                    currentValue={speaksValue}
                    key={field.id}
                    control={control}
                    register={register}
                    id={field.id}
                    remove={speaksRemove}
                    name="speak"
                    index={index}
                />
            ))}

            {speaksFields.length < 5 ? <button
                type="button"
                className='inline m-auto'
                onClick={() => {
                    speaksAppend({ lang: languages.filter((l) => !speaksValue.map((v) => v.lang).includes(l.value))[0].value, level: "C1" });
                }}
            >
                <FiPlusCircle size={30} color='#191d51' fontWeight={700} />
            </button> : ''}
            <h3 className="text-left mb-5">About Me</h3>


            <Controller
                name="description"
                control={control}
                defaultValue={description}
                rules={{
                    required: 'This field is required',
                }}
                render={({ field: { onChange } }) => (
                    <>
                        <label className="block text-left text-primary-grey text-[13px] font-semibold pb-1">Description</label>
                        <Editor
                            apiKey="po8apgru14vydxmcnorp2gqooxwp4xkytwq86a1iwiydx1wn"
                            value={description}
                            onEditorChange={onChange}
                            init={{
                                height: 300,
                                branding: false,
                                menubar: false,
                                placeholder: 'Write something...',
                                plugins: [
                                    'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount',
                                ],
                                toolbar:
                                    'undo redo | blocks | '
                                    + 'bold italic forecolor | alignleft aligncenter '
                                    + 'alignright alignjustify | bullist numlist outdent indent | '
                                    + 'removeformat | help',
                                content_style:
                                    'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                            }}
                        />
                        {errors && errors["description"]?.type === "required" && (
                            <span className="error text-left">{errors["description"]?.message}</span>
                        )}
                    </>

                )}
            />


            <TextInput
                type="url"
                name="youtube"
                label="Youtube Video"
                errors={errors}
                register={register}
                style={{ marginTop: "20px" }}
                validationSchema={{
                    required: "Youtube video is required",
                    validate: value => {
                        if (getYoutubeID(value) !== false)
                            return true;
                        return 'Incorrect Youtube url format'
                    }
                }}
                required={false}
            />
            <StepNavigation
                moveBack={previousStep === false ? false : () => setCurrentStep(previousStep)}
                moveForward={nextStep}
                isLoading={isLoading}
            />

        </form>
    )

}

export { TutorProfileStep }